import { render } from "./LoadingSection.vue?vue&type=template&id=5126ae0b&scoped=true"
import script from "./LoadingSection.vue?vue&type=script&lang=js"
export * from "./LoadingSection.vue?vue&type=script&lang=js"

import "./LoadingSection.vue?vue&type=style&index=0&id=5126ae0b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5126ae0b"]])

export default __exports__